import React, {useEffect, useMemo, useState} from 'react';

import TextField from '@mui/material/TextField';

import {ignoreTextFieldKeys, getRegexpDescription} from "ultra/helpers/utils";

import {useFormStore} from '../../../Stores/form';

export default function Path(props) {
    const {content, disabled, field, isEditMode, onChange, onBlur} = props;

    const {formVisibleErrors} = useFormStore();
    const showErrorText = formVisibleErrors[field.id];

    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
    useEffect(() => {setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled])

    const [regexpHighlight, setRegexpHighlight] = useState(false)

    const formatedRegexp = useMemo(() => {
        if (!field?.options?.regexp) return "";
        return "Доступні для вводу символи: " + getRegexpDescription(field.options.regexp);
    }, [field?.options?.regexp])

    const onKeyDownHandler = (e) => {
        if (!field?.options?.regexp) return false;
        const regex = new RegExp(field.options.regexp);

        if (((e.ctrlKey || e.metaKey) && e.key === 'v') || e.key === 'Enter') {
            if (!ignoreTextFieldKeys(e) && !regex.test(e?.target?.value)) {
                setRegexpHighlight(true);
            }
            else {
                setRegexpHighlight(false);
            }

            return false;
        }

        if (!ignoreTextFieldKeys(e) && !regex.test(e.key)) {
            e.preventDefault();
            setRegexpHighlight(true);
        }
        else {
            setRegexpHighlight(false);
        }
    }

    const onBlurHandler = (e) => {
        setRegexpHighlight(false);
        onBlur(e);
    }

    const onPasteHandler = (e) => {
        if (field?.options?.regexp) {
            const regex = new RegExp(field.options.regexp);
            const pastedData = (e.clipboardData || window.clipboardData).getData('text');
            if (!regex.test(pastedData)) {
                setRegexpHighlight(true);
                e.preventDefault();
            }
        }
    }

    return (<>
        <TextField
            error={Boolean(showErrorText)}
            helperText={showErrorText}
            fullWidth
            value={content[field.id] || ''}
            required={field.required}
            label={field.placeholder}
            variant="outlined"
            onKeyDown={onKeyDownHandler}
            onBlur={onBlurHandler}
            onPaste={onPasteHandler}
            onChange={onChange}
            disabled={isDisabled}
            // InputProps={{maxLength: field?.options?.maxLength}}
        />
        {!showErrorText && field?.options?.maxLength && <div className="fieldNotes">
            <p>* максимальна кількість символів - {field?.options?.maxLength}</p>
        </div>}

        {regexpHighlight && field?.options?.regexp && <div className={regexpHighlight ? "fieldNotes fieldNotesRegexpError" : "fieldNotes"}>
            <p>{formatedRegexp}</p>
        </div>}
    </>)
}
